module.exports = __webpack_public_path__ + "img/pro-p-slider23.4da9bc03.jpg";